export default __webpack_public_path__ + "static/flyerThumbnail-ce69c2287da2d5883b65dd3e12722d99.jpg";